import { FiltersContext } from "@/hooks/useFilters"
import { useMemo, useState } from "react"
import { CheckboxFilter } from "../CheckboxFilter"
import { CountedCheckboxFilter } from "../CountedCheckboxFilter"
import { DatePickerFilter } from "../DatePicker"
import { useSearchQueryProxy } from "../hooks/useSearchQueryProxy"
import { FixInsightsFilter, RiskInsightsFilter } from "../InsightsFilter"
import { KodemScoreFilter } from "../KodemScoreFilter"
import { OSLanguagesFilter } from "../OSLanguagesFilter"
import { RadioFilter } from "../RadioFilter"
import { RangePickerFilter } from "../RangePickerFilter"
import { TemplateFilter } from "../TemplateFilter"

const Provider = ({
  initialState,
  children,
  onChange: onChangeCb,
  useQueryString = true
}: any) => {
  const [filters, setFilters] = useState<Record<string, any>>({})
  const [searchParams, setSearchParams, searchParamsProps] =
    useSearchQueryProxy({
      initialState,
      useQueryString,
      onChangeCb
    })

  const value = useMemo(() => {
    return {
      searchParams,
      setSearchParams,
      searchParamsProps,
      filters,
      useQueryString,
      setFilters,
      onChange: (data: { name: string; value: any }) => {
        const { name, value } = data

        if (name && value !== undefined) {
          setFilters((prev) => ({ ...prev, [name]: value }))
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, setSearchParams, searchParamsProps.original])

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  )
}

export const Filter = {
  Provider,
  Checkbox: CheckboxFilter,
  CountedCheckbox: CountedCheckboxFilter,
  OsLanguage: OSLanguagesFilter,
  Insights: RiskInsightsFilter,
  FixInsights: FixInsightsFilter,
  KodemScore: KodemScoreFilter,
  DatePicker: DatePickerFilter,
  RangePicker: RangePickerFilter,
  Radio: RadioFilter,
  Template: TemplateFilter
}
